import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/user.svg'


const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  class: "size-7 mx-auto",
  alt: "user icon"
}
const _hoisted_2 = { class: "text-active mx-auto text-base leading-[20px]" }
const _hoisted_3 = { class: "min-h-[38px] min-w-[38px] md:min-h-[46px] md:min-w-[46px] flex items-center justify-center rounded-full bg-orange-gradient text-white transition-transform z-10 ml-auto" }

import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import { useI18n } from "vue-i18n";

import { useUserStore } from "@/stores/userStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginButton',
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const userStore = useUserStore();

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["bg-white h-[56px] relative flex items-center justify-between px-1 md:px-2 rounded-full", _unref(userStore).user !== null ? 'aspect-square' : 'w-[147px]']),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
  }, [
    (_unref(userStore).user !== null)
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)("buttons.auth.login")), 1),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(ArrowIcon, { class: "rotate-45" })
          ])
        ], 64))
  ], 2))
}
}

})